import styled from "@emotion/styled";

export const StyledCheckboxBlock = styled.div`
  background-color: ${({ theme }) => theme.palette.grey[50]};
  border-radius: 0 10px 10px 10px;
  border: ${({ theme }) => theme.palette.grey[200]} 1px solid;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  width: fit-content;
  box-sizing: border-box;
`;

export const StyledCheckboxLabel = styled.label`
  align-items: center;
  display: flex;
`;

export const StyledCheckboxHint = styled.p`
  color: ${({ theme }) => theme.palette.grey[500]};
`;
